<template>
  <div>
      
      <!-- 인스타그램 이벤트 -->
        <div class="contBox02 widM marTL padTL fntH6 txtC" style="border-top:3px dotted #000;color:#2c2c2c;">
            <div class="padTL padBL" style="background-color:#fff;">
                <div class="widXS">
                    <strong class="disBl fntH5 bolder" style="line-height:1.2;">
                        여기서 끝이 아니다! <br>
                        아티스트리가 마구마구 쏩니다!
                    </strong>
                    <div class="marTML fntP bold">
                        <img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/icon01.png" alt="인스타그램 아이콘" style="width:20%;max-width:100px;">
                        <div class="padTS">
                            <p class="marTS">
                                스킨 뉴트리션 퍼밍 <br class="moOnly">
                                울트라 리프팅 크림 미니 제품을 <br class="moOnly">
                                체험하신 후 본인 인스타그램에 <br class="moOnly">
                                아래 해시태그와 함께 후기를 남겨주세요. <br class="moOnly">
                                추첨을 통해 스킨 뉴트리션 본품을 보내 드립니다.
                            </p>
                            <p class="marTS">
                                <em class="disIb" style="background-color:#ffe4e4;margin:0.2em;padding:0.4em 0.8em;color:#71020f;border-radius:2em;">#아티스트리</em>
                                <em class="disIb" style="background-color:#ffe4e4;margin:0.2em;padding:0.4em 0.8em;color:#71020f;border-radius:2em;">#스킨뉴트리션</em>
                                <em class="disIb" style="background-color:#ffe4e4;margin:0.2em;padding:0.4em 0.8em;color:#71020f;border-radius:2em;">#건강한안티에이징의시작</em>
                            </p>
                            <p class="marTS">
                                스킨 뉴트리션이 출시되는 11월, <br>
                                본인 인스타그램의 DM을 확인해주세요
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
      <!-- 리뉴잉 & 퍼밍 미리 보기 -->
      <div class="contBox03 widM marTL padTL fntH6 txtC" style="border-top:3px dotted #000;color:#2c2c2c;">
          <strong class="disBl fntH4 fntM bolder" style="line-height:1.2;">
              스킨 뉴트리션 <br>
              리뉴잉 &amp; 퍼밍 미리 보기
          </strong>
          <div class="marTML fntP bold">
              <img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cont01_pc.jpg" class="pcOnly" alt="건강한 안티에이징의 시작 스킨 뉴트리션 : 시간을 멈추려면 스킨 케어만으로는 모자라니까 순간의 변화에 머무는 스킨 케어를 넘어- 깊은 곳으로 전달되는 파이토 에너지와 스킨 뉴트리션만의 독점 테르콜로지 리노베이팅 콤플렉스가 피부 스스로 피부를 지키는 힘을 키워갑니다">
              <img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cont01_mob_v2.jpg" class="moOnly" alt="건강한 안티에이징의 시작 스킨 뉴트리션 : 시간을 멈추려면 스킨 케어만으로는 모자라니까 순간의 변화에 머무는 스킨 케어를 넘어- 깊은 곳으로 전달되는 파이토 에너지와 스킨 뉴트리션만의 독점 테르콜로지 리노베이팅 콤플렉스가 피부 스스로 피부를 지키는 힘을 키워갑니다">
          </div>
      </div>
      <!-- 카드뉴스 -->
      <div class="contBox04 widM txtC">
          <!-- 카드뉴스 시작 -->         
          <div class="cardNews">
              <div class="card_swiper_wrap">
                  <div class="cardSection01">
                      <swiper class="swiper-wrapper" :options="swiperOption">
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_01.jpg" alt="ARTISTRY SKIN NUTRITION"></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_02.jpg" alt="건강한 안티에이징의 시작 스킨 뉴트리션 : 시간을 멈추려면 스킨 케어만으로는 모자라니까 순간의 변화에 머무는 스킨 케어를 넘어- 깊은 곳으로 전달되는 파이토 에너지와 스킨 뉴트리션만의 독점 테크놀로지 리노베이팅 콤플렉스가 피부 스스로 피부를 지키는 힘을 키워갑니다 [ARTISTRY PHYTO-FORCE 피부 광채, 피부 정화, 탄력, 항산화, 보습 진정] &dot; 리노베이팅 콤플렉스는 뉴트리라이트 스피니치, 티 올리브 플라워, 투메릭의 조합을 의미하며, 스킨 뉴트리션 일부 제품에 함유되어 있습니다. &dot; 주름개선을 통한 안티에이징을 의미하며, 스킨 뉴트리션 일부 주름개선 기능성 화장품에 한합니다. &dot; ARTISTRY PHYTO-FORCE의 피부 효능은 소비자의 이해를 돕기 위해 대표 성분들의 효능을 기재한 것으로, 모든 원료의 효능을 대표하지 않으며, 특정 제품의 효능효과와 직접적인 관계가 없습니다."></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_03.jpg" alt="어린 피부의 생명력을 되살리는 리뉴잉(RENEWING) #겨울에도 지지 않는 뿌리의 힘 #뿌리 에너지 [퓨리파이, 밸런스, 리빌드, 모이스처라이즈, 프로텍트]"></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_04.jpg" alt="리뉴잉 포밍 클렌저(RENEWING FOAMING CLEANSER) : 세정력부터 영양까지 쫀쫀하게 #밀착 클렌징 - 특별한 보습 성분이 선사하는 강력한 수분 장벽1), 5가지 자연 유래 오일의 깊은 영양2), 클렌징 후에도 당김 없는 탄력감 1) 히알루론산, 트레할로오스 / 원료적 효능에 한함 2) 멕시칸치아씨오일, 들깨오일, 달맞이꽃오일, 돌콩오일, 해바라기씨오일 / 원료적 효능에 한함 [퓨리파이]"></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_05.jpg" alt="리뉴잉 소프트닝 토너(RENEWING SOFTENING TONER) : 귀리 단백질이 선사하는 탄탄한 피부 #에센스 토너 - 자연 유래 귀리 단백질이 매끈하게 피부결 정돈1), 락토바실러스 발효물이 피부 기본기를 탄탄하게2), 풍부한 영양의 즉각적인 보습과 윤기 1), 2) 원료적 효능에 한함 [밸런스]"></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_06.jpg" alt="리뉴잉 리액티베이션 아이 크림(RENEWING REACTIVATION EYE CREAM) : 눈가 피부를 깊이 이해한 토탈 안티에이징 솔루션 #아이 버터 - 눈에 띄는 잔주룸, 깊은 주름, 꺼진 탄력, 어두운 피부 빛까지 한 번에, 세라마이드가 선사하는 24시간 강력 보습막, 피부에 닿는 순간 녹아드는 쫀쫀한 버터 텍스처 [리빌드, 모이스처라이즈, 프로텍트]"></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_07.jpg" alt="리뉴잉 밀키 에멀전(RENEWING MILKY EMULSION) : 속부터 채워지는 강력한 영양 #탄력 부스팅 로션 - 하루 두 번 자연의 강력한 항산화제, 비타민 E 충전1), 차세대 보습 성분 스쿠알란의 피부 수분 장벽 보호2), 끈적임 없이 탄력을 남기는 고보습 제형 1), 2) 원료적 효능에 한함 [리빌드, 모이스처라이즈, 프로텍트]"></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_08.jpg" alt="리뉴잉 리액티베이션 크림(RENEWING REACTIVATION CREAM) : 젊은 피부의 기억을 되살리는 #아이 버터 - 사용 15분 후 피부 주름 8.6%, 피부 빛 59% 개선1), 겨울에도 지지 않는 맥문동, 강황 뿌리의 강력한 항산화력2), 빠르고 매끄럽게 스며드는 풍부한 영양감의 텍스처 1) AIM Lab, n=39 2) 원료적 효능에 한함 [리빌드, 모이스처라이즈, 프로텍트]"></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_09.jpg" alt="긴 세월의 흔적마저 깊이 잠재우는 퍼밍(FIRMING) #빈틈 없는 탄성감 #쓰면 쓸수록* 올라가는 탄력! *한 달 사용 기준 [퓨리파이, 밸런스, 리빌드, 모이스처라이즈, 프로텍트]"></swiper-slide>
                        <swiper-slide><img src="https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/cardNews_arti_skin_nutrition_phase2_10.jpg" alt="퍼밍 울트라 리프팅 크림(FIRMING ULTRA LIFTING CREAM) : 쓰면 쓸수록1) 극강의 탄력을 선사하는 #울트라 리프팅 크림 - 사용 2주 후, 피부탄력 14.2% 개선, 사용 4주 후, 피부탄력 26.0% 개선2), 피부 자생력을 강화시키는 발효 에너지3), 짙은 노화의 흔적을 채워주는 빈틈 없는 탄성감 1) 한 달 사용 기준 2)AIM Lab, n=33 3) 효모/자일리눔/홍차발효물, 보리추출물, 원료적 효능에 한함 [리빌드, 모이스처라이즈, 프로텍트]"></swiper-slide>
                        <!-- Add Pagination -->
                        <!-- Add Pagination -->
                      <div class="swiper-pagination" slot="pagination"></div>
                      <!-- Add Navigation -->
                      <div class="swiper-button-prev" slot="button-prev"></div>
                      <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <!-- KCRM CODE -->
                    <div class="osResKCRM_wrap" style="background:0;">
                        <div class="osResKCRM">CB001876</div>
                    </div>
                    <!--// KCRM CODE -->
                  </div>
              </div>
          </div>
          <!-- 카드뉴스 끝 -->
      </div>
      <!-- 로고 -->
    <div class="contBox05 marTX padBM txtC">
        <img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_artistry_skin_nutrition.png" alt="Artistry Skin Nutrition(로고)" style="max-width:200px;min-width:116px;width:41.42%">
    </div>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css' 

  export default {
    name: 'swiper-example-loop',
    title: 'Loop mode / Infinite loop',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    }
  }
</script>


<style scoped>
/* 2020-10-07 카드뉴스 섹션 */
.card_swiper_wrap{width:100%;max-width:1200px;/*border-top:1px solid #e3e3e3;*/padding-top:40px;margin:0 auto;position:relative;}
.card_section{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;}
.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box;}
.swiper-container-android .swiper-slide, .swiper-wrapper {transform:translate3d(0px, 0, 0);}
.swiper-slide {flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;text-align:center;display:flex;align-items:center;justify-content:center;}
.swiper-slide img{max-width:100%;}

.swiper-button-prev, .swiper-button-next {width:36px;height:36px;position:absolute;top:50%;z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;margin-top:-18px;outline:none;background:url(https://www.amway.co.kr/_ui/responsive/theme-blue/images/akl_common/sprite/sp_akl.png) no-repeat 0 0;background-size:300px auto;}
.swiper-button-prev{left:10px;right:auto;background-position: 0 -40px !important;}
.swiper-button-prev:after{content:''}
.swiper-button-next{right:10px;left:auto;background-position: -40px -40px !important;}
.swiper-button-next:after{content:''}

.swiper-pagination {text-align:center;transition:300ms opacity;transform:translate3d(0, 0, 0);z-index:10;margin-top:20px;}
.swiper-pagination.swiper-pagination-hidden {opacity:0;}
.swiper-pagination-bullet {width:10px;height:10px;display:inline-block;border-radius:100%;background:#ebebeb;}
.swiper-pagination-bullets .swiper-pagination-bullet {margin: 0 4px;}
.swiper-pagination-bullet-active {color:#fff;background:#C70535;}

</style>


// WEBPACK FOOTER //
// src/views/nutrilite/waste-glass-bottle2/component/footer.vue